"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleRemoteVideoSourcesDidChange = void 0;
var _utils = require("./utils");
var _videoSharedState = require("./videoSharedState");
var _audioVideoHelpers = require("@studio/chime/audioVideo/audioVideoHelpers");
var _remoteVideoSourcesDidChangeHandler = require("@studio/chime/observers/audioVideo/RemoteVideoSourcesDidChange/remoteVideoSourcesDidChangeHandler");
var _featureFlags = require("@studio/feature.flags/featureFlags");
var _StudioLogger = require("@studio/logger/StudioLogger");
var logger = new _StudioLogger.StudioLogger('handleRemoteVideoSourcesDidChange');
var updateVideoPrioritiesOnStage = function updateVideoPrioritiesOnStage(videoSources, meetingSession) {
  var allSources = videoSources.filter(function (src) {
    return src.attendee.attendeeId;
  }).map(function (item) {
    return item.attendee.attendeeId;
  });

  // They maybe in the program but not in the video sources if there camera is off.
  var cameraAndScreenShareSourcesInProgram = (0, _videoSharedState.getSharedCameraAndScreenShareSourcesInProgram)().filter(function (src) {
    return allSources.includes(src);
  });

  // Now get everyone that has a video source but are not in the program.
  var cameraAndScreenShareSourcesNotInProgram = allSources.filter(function (src) {
    return !cameraAndScreenShareSourcesInProgram.includes(src);
  });
  var newVideoPreferences = (0, _utils.buildVideoPreferences)(cameraAndScreenShareSourcesInProgram, cameraAndScreenShareSourcesNotInProgram);

  // We always need to do this on this call.  Chime clears these out before calling us.
  (0, _audioVideoHelpers.chooseRemoteVideoSources)(meetingSession, newVideoPreferences);
  (0, _videoSharedState.setSharedPreviousVideoPreferences)(newVideoPreferences);

  // Log the count and IDs of users on stage vs not on stage
  logger.info('Chime video priority updated based on stage presence', {
    onStageCount: cameraAndScreenShareSourcesInProgram.length,
    onStageIds: cameraAndScreenShareSourcesInProgram,
    notOnStageCount: cameraAndScreenShareSourcesNotInProgram.length,
    notOnStageIds: cameraAndScreenShareSourcesNotInProgram
  });
};
var handleRemoteVideoSourcesDidChange = exports.handleRemoteVideoSourcesDidChange = function handleRemoteVideoSourcesDidChange(videoSources, meetingSession, meetingResponse) {
  if ((0, _featureFlags.shouldHaveFeature)('studio.onStagePriority')) {
    updateVideoPrioritiesOnStage(videoSources, meetingSession);
  } else {
    (0, _remoteVideoSourcesDidChangeHandler.remoteVideoSourcesDidChangeHandler)(videoSources, meetingSession, meetingResponse);
  }
};